import { logUserAction } from '@office-start/telemetry-service';
import { useCallback, useMemo } from 'react';
import { useDimeCallback } from './useDimeCallback';
import { useStorageErrorResources } from './useStorageErrorResources';
export var useUpsellButtonProps = function (dimeExperience) {
    var storageResources = useStorageErrorResources();
    var showDimeCallback = useDimeCallback(dimeExperience);
    var upsellClick = useCallback(function (subArea) {
        logUserAction({
            type: 'Click',
            id: 'StorageErrorUpsell',
            area: 'Upsell',
            subArea: subArea,
            result: 'Navigate',
            target: 'Other',
            eventName: 'StorageError_Upsell',
        });
        showDimeCallback && showDimeCallback();
    }, [showDimeCallback]);
    return useMemo(function () {
        if (!storageResources)
            return undefined;
        var upsellButtonProps = {
            caption: storageResources.upsellButtonText,
            description: storageResources.upsellButtonText,
            onClick: upsellClick,
            showDime: !!showDimeCallback,
        };
        return upsellButtonProps;
    }, [storageResources, upsellClick, showDimeCallback]);
};
//# sourceMappingURL=useUpsellButtonProps.js.map